/*
 * OASIS NATION — motion foundation
 * Lenis smooth/momentum scroll + GSAP ScrollTrigger.
 * Guarded: disabled in the Shopify theme editor and under reduced-motion.
 */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  function start() {
    if (typeof window.gsap === 'undefined') return;
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;
    if (ST) gsap.registerPlugin(ST);

    /* ---- Smooth scroll (skip in editor + reduced motion) ---- */
    if (!reduce && !designMode && typeof window.Lenis !== 'undefined') {
      var lenis = new window.Lenis({
        duration: 1.15,
        easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
        smoothWheel: true,
        wheelMultiplier: 1,
        touchMultiplier: 1.5
      });
      window.oasisLenis = lenis;

      if (ST) {
        lenis.on('scroll', ST.update);
        gsap.ticker.add(function (time) { lenis.raf(time * 1000); });
        gsap.ticker.lagSmoothing(0);
      } else {
        function raf(t) { lenis.raf(t); requestAnimationFrame(raf); }
        requestAnimationFrame(raf);
      }

      // Let nested scroll areas (cart drawer, modals) scroll natively
      document.querySelectorAll('.drawer__contents, .cart-drawer__form, .quick-add-modal__content, [data-lenis-allow]').forEach(function (el) {
        el.setAttribute('data-lenis-prevent', '');
      });

      // Anchor links should use Lenis for the smooth glide
      document.querySelectorAll('a[href^="#"]:not([href="#"])').forEach(function (a) {
        a.addEventListener('click', function (e) {
          var id = a.getAttribute('href');
          var target = document.querySelector(id);
          if (target) { e.preventDefault(); lenis.scrollTo(target, { offset: -80 }); }
        });
      });
    }

    if (!ST || reduce) return;

    /* ---- Scroll parallax: elements drift as their section scrolls ---- */
    gsap.utils.toArray('[data-parallax]').forEach(function (el) {
      var amount = parseFloat(el.getAttribute('data-parallax')) || 12; // percent
      gsap.fromTo(el,
        { yPercent: -amount },
        {
          yPercent: amount,
          ease: 'none',
          scrollTrigger: { trigger: el.closest('section') || el, start: 'top bottom', end: 'bottom top', scrub: true }
        }
      );
    });

    /* ---- Buttery rise-in for chapter elements ---- */
    gsap.utils.toArray('[data-rise]').forEach(function (el) {
      var delay = parseFloat(el.getAttribute('data-rise')) || 0;
      gsap.from(el, {
        y: 48,
        opacity: 0,
        duration: 1.1,
        delay: delay,
        ease: 'power3.out',
        scrollTrigger: { trigger: el, start: 'top 88%', once: true }
      });
    });

    /* ---- Scrubbed scale/clip reveal for chapter media ---- */
    gsap.utils.toArray('[data-rise-media]').forEach(function (el) {
      gsap.fromTo(el,
        { clipPath: 'inset(12% 8% 12% 8% round 8px)', scale: 1.08 },
        {
          clipPath: 'inset(0% 0% 0% 0% round 8px)',
          scale: 1,
          ease: 'power2.out',
          scrollTrigger: { trigger: el, start: 'top 90%', end: 'top 40%', scrub: true }
        }
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
